import { CART_MODULE } from "@/api_framework/api_config";
import { IUrgentCancelEditPayload, IUrgentCancelEditResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export type IUrgentCancelEditResult = { status: boolean; message: string };

/**
 * Sets the surviving quantity of a single draft-cart row. `new_qty` is the qty
 * that stays on the cart after the cancel, so 0 drops the row entirely.
 */
export const useUrgentCancelEditAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (payload: IUrgentCancelEditPayload): Promise<IUrgentCancelEditResult> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: IUrgentCancelEditResult = await axios
        .post(`${CART_MODULE?.URGENT_CANCEL_EDIT?.baseURL}`, payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IUrgentCancelEditResponse>) => ({
          status: res.data.status === true,
          message: res.data.message,
        }))
        .catch((e: AxiosError) => {
          sendCurl(e.config?.["curlCommand"]);
          captureError(e);
          return { status: false, message: "urgent_cancel_edit_failed" };
        });
      return response;
    } catch (e: any) {
      captureError(e);
      return { status: false, message: "urgent_cancel_edit_failed" };
    }
  }, []);

  return { execute };
};
